import React from 'react';
import CancelLogin from './CancelLogin';

const ConsentError = (props) => {

    let backToSelectionBtnText = props.theme.text.backToSelectionBtn;
    let requireWinz = false;

    const onCancel = () => {
        props.dispatch({ type: 'LOGIN_PROCESS_CANCELLED' });
    }

    return (
        <div id="intro">
            <div className="consent-data-wrapper transfer-to-provider">
                <h2 className="form-group text-center">
                    Notice
                </h2>
                <p>Unfortunately, you have not authorized {props.institution.name} to share your account information with us.</p>
                <p>Please select an institution to continue.</p>
                <CancelLogin
                    action={onCancel}
                    theme={props.theme}
                    backToSelectionBtnText={backToSelectionBtnText}
                    requireWinz={requireWinz}
                />
            </div>
        </div>
    );
};

export default ConsentError;